export const getDecimalValue = (value, decimals = 2) => { // 0.345 => 0.35 | 0.344 => 0.34
  decimals = 10 ** decimals;
  return (Math.round((parseFloat(value) + Number.EPSILON) * decimals) / decimals);
}

export const formatNumberWithSpaces = (number) => {
  const numberStr = !isNaN(Number(number)) ? getDecimalValue(Number(number)).toString() : '';
  return numberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const formatPhoneNumber = (phone) => {
  const cleaned = phone.replace(/(?!^\+)\D/g, '');
  const match = cleaned.match(/^(\+3\d{1})(\d{9})$/);
  if (match) {
    const countryCode = match[1]
    const digits = match[2];
    const formatted = `${countryCode} ${digits[0]} ${digits.slice(1, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7)}`;
    return formatted;
  }
  return phone
}